/**
 * Strips parenthesized segments from a display name, e.g.
 * "Corporate Number (Hōjin Bangō)" -> "Corporate Number".
 * Falls back to the original string if stripping would leave it empty.
 */
export const stripParenthetical = (name: string): string => {
  const stripped = name
    .replace(/\s*\([^()]*\)/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
  return stripped || name;
};
